import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function FeeGroupsPage(){ return <ExtendedModulePage moduleKey="fee-groups"/>; }
